import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

export const PrivateRoute = ({ redirectPath = '/login', children, }) => {

    if (!localStorage.getItem(process.env.REACT_APP_LS_USER)) {
        
        return <Navigate to={redirectPath} replace />;
    }

    return children ? children : <Outlet />;

};
export default PrivateRoute;